/* eslint-disable react/jsx-props-no-spreading */

import { forwardRef } from 'react';

import routes from 'constants/routes';

import useCustomMediaQuery from './useMediaQuery';

/**
 * @description Provides default route that should be used when we want to redirect user to some kind of main/landing page.
 * Currently is mobile default page is homepage and desktop it's markets page.
 * It would serve as a single source of handling routes for default views. Also can change default view based on certain conditions within this hook.
 * So it will get reflected across the app.
 */
const useDefaultRedirectRoute = () => {
  const { whenBelowMd } = useCustomMediaQuery();

  return whenBelowMd ? routes.homepage.default : routes.webAppHome;
};

/**
 * @description Just a wrapper over above hook, as hoc for class based components.
 */
const withDefaultRedirectRoute = Component => {
  const ComponentWithDefaultRedirectRoute = forwardRef((props, ref) => {
    const defaultRedirectRoute = useDefaultRedirectRoute();

    return <Component {...props} defaultRedirectRoute={defaultRedirectRoute} ref={ref} />;
  });

  return ComponentWithDefaultRedirectRoute;
};

export { useDefaultRedirectRoute, withDefaultRedirectRoute };
